<template>
  <div>
    <KeyboardEvents @keyup="keyboardEvent" />
    <loading
      :active.sync="$store.getters.isLoading"
      :can-cancel="false"
      :height="32"
      :is-full-page="true"
      :width="32"
    />

    <!-- /.login-logo -->
    <b-row
      class="p-0 m-0"
      style="background: #f4f6f9"
    >
      <b-col
        align-self="center"
        class="left-section p-0 m-0"
        lg="4"
        md="12"
      >
        <div class="login-div p-0">
          <div class="login-logo mb-3">
            <img
              alt="TENACY"
              class="logo-login-img"
              :src="`${publicPath}static/img/Tenacy_couleur_borderless.svg`"
            />
          </div>

          <div class="mb-3 d-inline-flex">
            <b-button
              v-if="step > 1"
              class="go-back mr-2"
              variant="outline-primary"
              @click="step = 1"
            >
              <i
                v-if="step > 1"
                class="far fa-arrow-left"
                @click="step = 1"
              />
            </b-button>
            <span
              v-if="step > 1"
              style="overflow-wrap: anywhere"
              >{{ emailInput }}</span
            >
            <br v-if="step > 1" />
          </div>

          <form @submit.prevent.stop="$emit('dummy')">
            <FormField
              v-show="step === 1"
              ref="email"
              v-model="emailInput"
              autocomplete="username"
              :disabled="step != 1"
              :error="emailError"
              :label="_('Email')"
              name="email"
              no-check
              placeholder="contact@example.com"
              type="text"
              @check-value="autofillCheck($event, 'emailInput')"
            />

            <FormField
              ref="password"
              v-model="passwordInput"
              autocomplete="current-password"
              :class="{ 'd-none': step === 1 }"
              :datahidden="step === 1"
              :label="_('Password')"
              name="password"
              no-check
              :placeholder="_('Password')"
              :style="password_style"
              type="password"
              @check-value="autofillCheck($event, 'passwordInput')"
            />

            <FormField
              v-if="step === 3"
              ref="authentication_code"
              v-model="authenticationCodeInput"
              :datahidden="step === 1"
              :error="authenticationCodeError"
              :label="_('Authentication code')"
              name="authentication_code"
              no-check
              :placeholder="_('Authentication code')"
              :style="authentication_code_style"
              @blur="authenticationCodeOnBlur"
            />

            <div class="row">
              <div class="col-12">
                <b-button
                  v-if="step === 1"
                  id="sign_in1"
                  ref="sign_in1"
                  class="w-100 login-button tenacy-btn ripple"
                  :disabled="loading"
                  href="#"
                  variant="primary"
                  @click.stop="signIn"
                >
                  <translate key="next">Next</translate>
                </b-button>
                <b-button
                  v-else
                  ref="sign_in2"
                  class="w-100 login-button login-button tenacy-btn ripple"
                  href="#"
                  variant="primary"
                  @click.stop="signIn"
                >
                  <translate key="si">Sign in</translate>
                </b-button>
              </div>
            </div>
            <div
              v-if="loading"
              class="text-center mt-2"
            >
              <i class="fa fa-2x text-primary fa-circle-notch fa-spin" />
            </div>
          </form>
          <b-row class="mt-3">
            <b-col class="text-right"
              ><a
                href="#"
                @click="forgotPassword"
              >
                <translate>I forgot my password</translate>
              </a></b-col
            >
          </b-row>
        </div>
      </b-col>
      <AuthColRight class="hide-col" />
    </b-row>
  </div>
</template>

<script>
import { nextTick, ref } from 'vue'
import Loading from 'vue-loading-overlay'
import FormField from '@/components/ui/FormField.vue'
import vv_fr from 'vee-validate/dist/locale/fr'
import UnauthPageMixin from '@/mixins/UnauthPageMixin'
import KeyboardEvents from '@/components/ui/KeyboardEvents.vue'
import AuthColRight from '@/components/ui/AuthColRight.vue'
import throttle from 'lodash/throttle'
import { isLanguageFrench } from '@/helpers/Language.helpers'
import { useFormValidation } from '@/contexts/shared/form-validation/UseFormValidation.composables'
import { ValidateOn } from '@/contexts/shared/form-validation/FormValidation.interfaces'
import { emailSchema, passwordSchema, authenticationCodeSchema } from '@/components/unauth-pages/SignInView.helpers'

export default {
  name: 'SignInView',
  components: {
    FormField,
    Loading,
    KeyboardEvents,
    AuthColRight,
  },
  mixins: [UnauthPageMixin],
  setup() {
    const step = ref(1)

    const {
      validators: {
        email: { input: emailInput, error: emailError },
        password: { input: passwordInput },
        authentication_code: {
          input: authenticationCodeInput,
          error: authenticationCodeError,
          onBlur: authenticationCodeOnBlur,
        },
      },
      validate,
      valid,
      resetValidation,
    } = useFormValidation(
      {
        email: {
          schema: emailSchema(),
          value: '',
          validateOn: ValidateOn.CHANGE,
        },
        password: {
          schema: passwordSchema(),
          value: '',
        },
        authentication_code: {
          schema: authenticationCodeSchema(step),
          value: '',
        },
      },
      { validateOn: ValidateOn.BLUR }
    )

    return {
      step,
      emailInput,
      emailError,
      passwordInput,
      authenticationCodeInput,
      authenticationCodeError,
      authenticationCodeOnBlur,
      validateForm: validate,
      isFormValid: valid,
      resetFormValidation: resetValidation,
    }
  },
  data: function () {
    return {
      recaptca_enabled: false,
      publicPath: import.meta.env.BASE_URL,
    }
  },
  computed: {
    password_style() {
      if (this.step === 2 || this.step === 3) {
        return {}
      } else {
        return {
          opacity: 0,
          height: '0px !important',
          'margin-bottom': '0',
        }
      }
    },
    authentication_code_style() {
      if (this.step === 3) {
        return {}
      } else {
        return {
          opacity: 0,
          height: '0px !important',
          'margin-bottom': '0',
        }
      }
    },
  },
  mounted() {
    if (isLanguageFrench()) {
      this.$language.current = 'fr_FR'
    } else {
      this.$language.current = 'en_US'
    }
    this.focusInput()
  },
  methods: {
    autofillCheck(event, field) {
      if (this[field] !== event) {
        this[field] = event
      }
    },
    signIn: function () {
      if (this.step === 1) {
        this.$refs.email.triggerCheckValue()
        this.signIn1()
      } else if (this.$refs.password) {
        this.$refs.password.triggerCheckValue()
        this.signIn2()
      }
    },
    focusInput() {
      let found = false
      if (this.step === 1) {
        if (this.$refs.email) {
          this.$refs.email.focus()
          found = true
        }
      } else if (this.step === 2 || this.step === 3) {
        if (this.$refs.password) {
          this.$refs.password.focus()
          found = true
        }
      }

      if (!found) {
        setTimeout(() => {
          this.focusInput()
        }, 200)
      }
    },
    processError(err, unloading = true) {
      if (unloading) {
        this.$store.commit('unloading')
      }
      this.$log.debug(err)
      this.$toast.alert(err)
      this.emailInput = ''
      this.passwordInput = ''
      this.authenticationCodeInput = ''
      this.resetFormValidation()
      if (this.$refs.email) {
        this.$refs.email.touched = false
      }
      if (this.$refs.password) {
        this.$refs.password.touched = false
      }
      if (this.$refs.authentication_code) {
        this.$refs.authentication_code.touched = false
      }
    },
    signIn1: async function () {
      await this.validateForm()
      if (!this.isFormValid) {
        this.$log.debug('VALIDATION FAILED')
        return
      }
      this.loading = true
      const email = this.emailInput
      this.$store
        .dispatch('login1', { email })
        .then((user) => {
          this.loading = false
          if (user && user.saml) {
            this.$toast.info(user.message)
            window.location.href = user.redirect
          } else if (user && user.mfa) {
            this.step = 3
            nextTick(() => this.focusInput())
          } else if (user) {
            this.step = 2
            nextTick(() => this.focusInput())
          } else {
            throw new Error()
          }
        })
        .catch((err) => {
          this.$log.error(err)
          this.loading = false
          this.processError(this._('Network error'), false)
        })
    },
    signIn2: async function () {
      await this.validateForm()
      if (!this.isFormValid) {
        return
      }
      this.$store.commit('loading')
      const email = this.emailInput
      const password = this.passwordInput
      const authentication_code = this.authenticationCodeInput
      this.$store
        .dispatch('login', { email, password, authentication_code })
        .then((user) => {
          this.$store.commit('unloading')
          if (user.saml) {
            this.$log.error('Internal error, SAML redirect failed')
          } else {
            if (user.lang === 'fr') {
              this.$language.current = 'fr_FR'
              // Must keep until vee-validate is fully removed: sets the locale for vee-validate messages
              // on all pages not yet migrated to useFormValidation.
              this.$validator.localize('fr', vv_fr)
            } else {
              this.$language.current = 'en_US'
            }
            if (this.$route.query.redirect) {
              this.$router.push(this.$route.query.redirect).catch(() => {})
            } else {
              this.$router.push(this.$store.getters.isPublic ? '/admin/customer' : '/home').catch(() => {})
            }
          }
        })
        .catch((err) => {
          const responseMessage = err.response?.data?.message
          this.processError(responseMessage ?? err)
          this.step = 1
        })
    },
    forgotPassword: function () {
      this.$router.push({ name: 'forgot_password' }).catch(() => {})
    },
    keyboardEvent: throttle(
      function (e) {
        if (e.which === 13) {
          this.$log.debug('SIGN IN !!')
          this.signIn()
        }
      },
      200,
      { leading: false, trailing: true }
    ),
  },
}
</script>

<style scoped>
.login-div {
  margin: 22% !important;
}
.left-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100vh;
  padding-left: 4px;
}
</style>
